/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicProviderRecommendations extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicProviderRecommendations");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicProviderRecommendations.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicProviderRecommendations>): BackgroundJobPayloadForPeriodicProviderRecommendations {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicProviderRecommendations(), model);
        BackgroundJobPayloadForPeriodicProviderRecommendations.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicProviderRecommendations>): BackgroundJobPayloadForPeriodicProviderRecommendations {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicProviderRecommendations.newInstance(<BackgroundJobPayloadForPeriodicProviderRecommendations> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicProviderRecommendations) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicProviderRecommendations.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicProviderRecommendations): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicProviderRecommendations.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
